import React, { useState } from "react";
import Icon from "@ant-design/icons";
import DataServices from "../../../Services/DataServices";
import IntlMessages from "../../../util/IntlMessages";
import { Collapse, Tabs, Drawer, Col } from "antd";
import CustomScrollbars from "../../../util/CustomScrollbars";
import { useHistory, useRouteMatch } from "react-router";
import {
  loadInventoryTakesItemsData,
  loadIsInventoryTakesItemsLoading,
} from "../../../appRedux/actions/Inventory";
import { useDispatch, useSelector } from "react-redux";
import { Row } from "reactstrap";

const InventoryProductItemRightPanel = (props) => {
  const Panel = Collapse.Panel;
  const [Loader, setLoader] = useState(false);
  const { TabPane } = Tabs;
  const history = useHistory();
  const dispatch = useDispatch();

  //#region useSelector
  const getReduxInventoryProductData = useSelector(
    ({ Inventory }) => Inventory.getInventoryProductData
  );
  //#endregion useSelector

  //#region Change Functions, OnClick Form Save

  const onSelectProduct = (product) => {
    let inventoryProducts = [...getReduxInventoryProductData];
    let tempObj = getReduxInventoryProductData.filter(
      (e) => e.key == product.key
    )[0];
    tempObj.IsCounted = false;
    tempObj.Counted = "0";
    tempObj.IsChange = true;
    dispatch(loadInventoryTakesItemsData(inventoryProducts));
  };
  //#endregion Change Functions, OnClick Form Save

  //#region Components
  const ProductItemCell = ({ key, product }) => {
    return (
      <div className={`gx-chat-user-item`} key={key}>
        <div className="gx-chat-user-row">
          <div className="gx-chat-avatar">
            <div className="gx-status-pos">{product.Counted}</div>
          </div>

          <div className="gx-chat-contact-col">
            <div className="h4 gx-name">{product.ProductName}</div>
          </div>

          <div
            className="gx-module-todo-right del-btn-div"
            onClick={() => {
              onSelectProduct(product);
            }}
          >
            <span>
              <a className="trash-icon-btn">
                {" "}
                <i className="icon icon-trash" />
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  };

  const ProductList = () => {
    return (
      <div className="gx-chat-sidenav-main">
        <div className="gx-chat-sidenav-content">
          <CustomScrollbars className="gx-chat-sidenav-scroll-tab-2">
            <div className="gx-chat-user cui-div">
              {getReduxInventoryProductData &&
                getReduxInventoryProductData
                  .filter((e) => e.IsCounted == true)
                  .map((product, index) => (
                    <ProductItemCell key={index} product={product} />
                  ))}
            </div>
          </CustomScrollbars>
        </div>
      </div>
    );
  };

  //#endregion Components

  return (
    <>
      <div id="drawer-container" className="InventoryCount-List">
        <Row>
          <Col lg={24} md={24} sm={24} xs={24}>
            <h1 className="counteditems-h1">
              <IntlMessages id="products.inventoryCount.inventorycountitemdetails.yourlastcounteditems" />
            </h1>
          </Col>

          <Col lg={24} md={24} sm={24} xs={24}>
            <ProductList />
          </Col>
        </Row>
      </div>
    </>
  );
};
export default InventoryProductItemRightPanel;
